import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializePurchaseOrderUpdate } from './serialize';

/** PATCH `/srm/purchase-order/{id}`。含 updatedAt 樂觀鎖。 */
export async function updatePurchaseOrder(id, payload) {
  const { data: raw } = await request.patch(
    `/srm/purchase-order/${id}`,
    serializePurchaseOrderUpdate(payload),
  );
  return parseVer4DetailResponse(raw);
}
